const Palette = {
  BLUE: {
    id: '5',
    colors: ['#1852AA', '#E6F0FF', '#85B5FF', '#103671', '#206DE2']
  },
  RED: {
    id: '2',
    colors: ['#861A1B', '#F9E7E7', '#E18788', '#591112', '#C92729']
  },
  GREEN: {
    id: '1',
    colors: ['#217238',	'#E7F3EA', '#89C399', '#175128', '#2B9348']
  },
  GRAY: {
    id: '3',
    colors: ['#495057', '#E9ECEF', '#ADB5BD', '#343A40', '#495057']
  },
  ORANGE: {
    id: '4',
    colors: ['#D97000' ,'#FEF0E2' ,'#FAB771', '#A45400', '#F77F00']
  }
}

export default Palette
